// extracted by mini-css-extract-plugin
module.exports = {"results":"Results_results__1-GjU","tabs":"Results_tabs__3_bxs","item":"Results_item__3L18Y"};